import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContentText from "@mui/material/DialogContentText";
import { withStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import classNames from "classnames";

const NotifyMessageDialog = ({ name, title, description, open, closeHandler, closeButtonText, icon, classes }) => {
  return (
<Dialog open={open} onClose={closeHandler} aria-labelledby={`${name}-title`} aria-describedby={`${name}-description`}>
<DialogContent className={classes.dialogContent}>
<DialogTitle id={`${name}-title`} className={classes.dialogTitle}>
       {title}
</DialogTitle>
<Typography id={`${name}-description`} className={classes.dialogDescription}>
       {description}
</Typography>
<Button
       onClick={closeHandler}
       className={classes.button}
       autoFocus
       disableElevation
       variant="contained"
>
       {closeButtonText}
</Button>
</DialogContent>
</Dialog>
);
};
const styles = theme => ({
 dialogContent: {
   maxWidth: 420, // wider
   padding: '24px 32px',
   textAlign: 'center'
 },
 centerContent: {
   display: 'flex',
   justifyContent: 'center',
   flexDirection: 'column',
   alignItems: 'center'
 },
 button: {
   width: 160,
   marginTop: 12,
   backgroundColor: '#E30613', // Pru red
   color: '#fff',
   fontWeight: 500,
   borderRadius: 1000,
   '&:hover': {
     backgroundColor: '#c10410'
   }
 },
 dialogTitle: {
   fontWeight: '700',
   fontSize: '1.125rem',
   color: '#111', 
   fontFamily: 'Open Sans, sans-serif',
   marginBottom: 4
 },
 dialogDescription: {
   fontSize: '1rem',
   color: '#222',
   fontFamily: 'Open Sans, sans-serif',
   marginBottom: 12,
   lineHeight: 1.4
 },
});

export default withStyles(styles, { withTheme: true })(NotifyMessageDialog);
